import { createContext } from 'react';
//
import { MsalContextType } from '../../types';

// ----------------------------------------------------------------------

export const AuthContext = createContext({} as MsalContextType);
